import { Helmet } from "react-helmet";

export const StructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "https://skylofiatc.lovable.app/#website",
        "url": "https://skylofiatc.lovable.app/",
        "name": "Sky Lofi ATC - Lofi Hip Hop Beats with Live Air Traffic Control Radio",
        "description": "Stream ambient lofi music mixed with real-time ATC communications from airports worldwide. Perfect for studying, coding, and deep focus.",
        "inLanguage": "en-US",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://skylofiatc.lovable.app/?s={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "MusicRecording",
        "@id": "https://skylofiatc.lovable.app/#musicrecording",
        "name": "Sky Lofi ATC Live Stream",
        "description": "24/7 live stream combining lofi hip hop beats with authentic air traffic control radio communications from major international airports",
        "genre": ["Lofi Hip Hop", "Study Music", "Ambient", "Chill Beats"],
        "duration": "PT24H",
        "inLanguage": "en-US",
        "keywords": "lofi, lofi hip hop, ATC radio, air traffic control, study music, focus music, chill beats, ambient music, lofi ATC, study beats, concentration music"
      },
      {
        "@type": "RadioBroadcastService",
        "@id": "https://skylofiatc.lovable.app/#broadcast",
        "name": "Sky Lofi ATC Stream",
        "broadcastFrequency": "Online Streaming",
        "description": "Free 24/7 streaming service featuring lofi music and live ATC feeds",
        "genre": ["Lofi Hip Hop", "Aviation Radio", "Study Music"],
        "inLanguage": "en-US"
      },
      {
        "@type": "Organization",
        "@id": "https://skylofiatc.lovable.app/#organization",
        "name": "Sky Lofi ATC",
        "url": "https://skylofiatc.lovable.app/",
        "logo": "https://skylofiatc.lovable.app/favicon.ico",
        "sameAs": [],
        "description": "Providing free, ad-free lofi hip hop music streams combined with live air traffic control radio for studying, working, and relaxation"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
